<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/technical-support/technical-support']">
        <span translate>COMMONS.TECHNICAL_SUPPORT</span>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>COMMONS.INCIDENTS</span>
</div>

<tb-header parentPage="incidentfinder"></tb-header>
<div class="contentGlobal">

  <div class="course-card-container">
    <mat-card class="course-card course-card--filters" *ngIf="!isLoading">
      <mat-card-header>
        <mat-card-title translate>COMMONS.SEARCHINCIDENTS</mat-card-title>
      </mat-card-header>
      <div [formGroup]="search">
        <div class="filters-container">

          <mat-form-field appearance="outline">
            <mat-label><mat-label translate>COMMONS.COURSEPRODUCT</mat-label></mat-label>
            <mat-select (selectionChange)="selectNone($event.value, 'product')" formControlName="product" [disabled]="!enabledInput().includes('product')">
              <mat-option value=""><span translate>COMMONS.SELECTALL</span></mat-option>
              <mat-option *ngFor="let product of improvementRequestSearch.Products" [value]="product.ProductCode">{{product.Description}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label><mat-label translate>COMMONS.RELEASE</mat-label></mat-label>
            <mat-select (selectionChange)="selectNone($event.value, 'release')" formControlName="release" [disabled]="!enabledInput().includes('release')">
              <mat-option value=""><span translate>COMMONS.SELECTALL</span></mat-option>
              <mat-option *ngFor="let release of releases" [value]="release">{{release}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label translate>PRODUCTS.FUNCAREA</mat-label>
            <mat-select (selectionChange)="selectNone('', 'functionalArea')" formControlName="functionalArea" [disabled]="!enabledInput().includes('functionalArea')">
              <mat-option value=""><span translate>COMMONS.SELECTALL</span></mat-option>
              <mat-option *ngFor="let area of improvementRequestSearch.FunctionalAreas" [value]="area[descriptionToShow]">{{area[descriptionToShow]}}</mat-option>
            </mat-select>
          </mat-form-field>

        </div>
        <div class="inputSearchStyle" >

          <mat-form-field appearance="outline">
            <mat-label translate>COMMONS.SEARCH</mat-label>
            <mat-icon matPrefix [inline]="true">search</mat-icon>
            <mat-chip-list #chipList formArrayName="searchString">
              <mat-chip
                *ngFor="let tag of search.get('searchString').controls; let i=index;"
                [selectable]="true"
                [removable]="true"
                (removed)="remove(search, i)">
                {{getTagSubStr(tag.value)}}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input placeholder="{{ 'COMMONS.SEARCH' | translate }}"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="add($event, search)">
            </mat-chip-list>
            <mat-error><span translate>COMMONS.SEARCHERROR</span></mat-error>
          </mat-form-field>

        </div>

        <p translate>
          COMMONS.SEARCHINCIDENTINFO
        </p>

        <div style="text-align: end;">
          <button style="align-self: flex-end;" mat-flat-button class="left" color="primary" [disabled]="!enabledInput().includes('button')" (click)="searchIncidents()">
            <span translate>COMMONS.SEARCH</span>
          </button>
        </div>
      </div>

    </mat-card>

    <div class="incidents-container">
      <mat-card class="course-card course-card--courses" style="margin: 0 !important; width: 100%;">
        <mat-card-header>
          <mat-card-title><span translate>COMMONS.INCIDENTS</span></mat-card-title>
        </mat-card-header>

        <div style="margin-top: 2rem;">
          <span translate style="font-size: 1rem;">COMMONS.FILTER_BY</span>:
          <div class="filters-container">
            <mat-form-field appearance="outline">
              <mat-label translate>COMMONS.PUBLICATION_DATE</mat-label>
              <mat-date-range-input [formGroup]="filters" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="{{ 'COMMONS.STARTDATE' | translate }}">
                <input matEndDate formControlName="end" placeholder="{{ 'COMMONS.ENDDATE' | translate }}">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>

        <mat-card-content *ngIf="productDto && !isLoading">
          <ms-reports [functionalArea]="getSelectedFunctionalArea()" [searchString]="searchString()" [productDto]="productDto" [genericFilters]="filters" [reportType]="'INCIDENTS'"></ms-reports>
        </mat-card-content>
      </mat-card>
    </div>

  </div>

</div>
<div *ngIf="isLoading || isLoadingReleases">
    <tb-loading></tb-loading>
</div>
